/**
 * Copy sourced from Monday form view 52526385 on board 5098952022 (habait4u).
 * Keep in sync when the native form changes.
 */

export const AGRITOUR_FORM_TITLE =
  'בחינה להגשה עבור נוהל התמיכה למיזמי תיירות חקלאית לשנת 2027';

export const AGRITOUR_WELCOME = {
  title: 'שאלון בדיקת היתכנות למיזם תיירות חקלאית - משרד החקלאות',
  paragraphs: [
    'ברוכים הבאים לשאלון בחינת התאמה למיזמי תיירות חקלאית ביישובי קו העימות.',
    'מטרת השאלון היא לסייע לנו להכיר את המיזם, להבין את שלב הפיתוח שבו הוא נמצא ולבחון את התאמתו לתנאי הקול הקורא לתמיכה במיזמי תיירות חקלאית לשנת 2027.',
    'מילוי השאלון אינו מהווה הגשת בקשה רשמית ואינו מבטיח קבלת תמיכה, אך הוא יאפשר לנו לתת לכם הכוונה ראשונית, לזהות הזדמנויות וחסמים, ולסייע בבחינת המשך התהליך.',
    'אנו ממליצים למלא את השאלון באופן מלא ומדויק ככל האפשר.',
    'בהצלחה,',
    'אשכול גליל מזרחי',
    'תחום התיירות החקלאית',
  ],
  button: 'לחץ להתחלת המענה',
  draftNote:
    'ניתן לשמור טיוטה במהלך המילוי ולחזור אליה מאוחר יותר באמצעות קישור ייחודי.',
};

export const AGRITOUR_DRAFT_COPY = {
  saveButton: 'שמור כטיוטה',
  modalTitle: 'שמירה כטיוטה',
  modalBody:
    'מלאו את הטופס מאוחר יותר או שתפו את הקישור עם מישהו אחר להשלמה',
  copyButton: 'העתקת קישור',
  copiedButton: 'הועתק!',
  closeButton: 'סגירה',
  disclaimer: 'חתימה וקבצים מצורפים לא נשמרים בשמירת טיוטה',
  expiryNote: 'הקישור תקף ל-7 ימים',
  saveError: 'לא ניתן לשמור את הטיוטה. נסו שוב.',
  minFieldsError: 'יש למלא לפחות שם יזם או שם מיזם לפני שמירת טיוטה',
  loadError: 'לא ניתן לטעון את הטיוטה — ייתכן שהקישור פג תוקף.',
  loadingDraft: 'טוען טיוטה...',
};

export const AGRITOUR_SECTIONS = {
  a: {
    title: "חלק א': פרטי היזם ופרטי התקשרות",
    stepLabel: "חלק א'",
  },
  b: {
    title: "חלק ב': מידע מרחבי, תכנוני, קנייני וסטטוטורי (מיקום המיזם)",
    intro:
      'חלק זה קריטי לבחינת תנאי הסף של זיקה לקרקע ובשלות סטטוטורית.',
    stepLabel: "חלק ב'",
    parcelIds: 'פרטי זיהוי מקרקעין',
    coordinates: 'מיקום המיזם על המפה',
    itmEasting: 'מזרח (ITM)',
    itmNorthing: 'צפון (ITM)',
    itmHint: 'ניתן לסמן על המפה או להזין ידנית מזרח וצפון ברשת ישראל החדשה',
    itmPolygonConfirm:
      'הזנת נ.צ ידנית תמחק את הפוליגון ותעבור למצב נקודה. להמשיך?',
    itmPolygonModeNote: 'במצב פוליגון — המיקום נקבע לפי השטח המסומן',
    landDocs: 'מסמכי זיקה לקרקע קיימים -',
  },
  c: {
    title: "חלק ג׳: מאפייני המיזם, תפעול ותשתיות",
    intro:
      'חלק זה נועד להעריך את אופי הפעילות, הרגישות הסביבתית וצרכי הפיתוח הפיזיים.',
    stepLabel: "חלק ג'",
    utilities: 'צרכי ותשתיות מים, חשמל וביוב -',
    accessParking: 'נגישות תחבורתית וחנייה -',
    hoursLighting: 'שעות פעילות, תאורה והגברה (הערכת השפעה סביבתית/מטרדים) -',
    visitors: 'צפי מבקרים ותפוסה -',
  },
  d: {
    title: 'הגשה וחתימה',
    stepLabel: 'הגשה',
  },
};

export const AGRITOUR_SUCCESS = {
  title: 'תודה רבה!',
  body: 'הטופס נשלח בהצלחה. נציג מטעמנו ייצור איתך קשר בהקדם.',
};

export const AGRITOUR_SUPPORT = {
  label: 'לתמיכה - סיוון צרפתי אור',
  phone: '0503255444',
  email: 'info@galil-golan.co.il',
};

export const YES_NO = [
  { value: '0', label: 'כן' },
  { value: '1', label: 'לא' },
];

export const SEASONAL_OR_PERMANENT_OPTIONS = [
  { value: '0', label: 'עונתי' },
  { value: '1', label: 'קבוע' },
];

export const LEGAL_ENTITY_OPTIONS = [
  { value: '0', label: 'חקלאי יחיד / חבר אגודה' },
  { value: '1', label: 'שותפות רשומה' },
  { value: '2', label: 'חברה בע"מ' },
  { value: '3', label: 'אגודה חקלאית' },
  { value: '5', label: 'אחר' },
];

export const OWNERSHIP_OPTIONS = [
  { value: '0', label: 'קרקע מדינה (רשות מקרקעי ישראל - רמ״י)' },
  { value: '1', label: 'אחר' },
  { value: '3', label: 'קרקע פרטית' },
];

export const PARCEL_TYPE_OPTIONS = [
  { value: '0', label: 'הקרקע אינה חלק ממשבצת חקלאית יישובית' },
  { value: '1', label: 'בקיבוץ: משבצת חקלאית, תחום המחנה, תעשייה או מבנים חקלאיים' },
  { value: '2', label: 'חווה חקלאית' },
  { value: '3', label: 'במושבה: חלקה צמודה למגורים או מרוחקת' },
  { value: '4', label: "במושב: חלקה א' (מגורים וצמוד דופן), ב' או ג" },
];

export const STATUTORY_MATURITY_OPTIONS = [
  { value: '0', label: 'המיזם פטור מהיתר בנייה' },
  { value: '1', label: 'הוגשה בקשה להיתר בנייה במערכת רישוי זמין' },
  { value: '2', label: 'קיים היתר בנייה חתום ותואם לשימוש המבוקש' },
  { value: '3', label: 'היתר הבנייה נמצא בשלב בקרת תכן בוועדה המקומית' },
  { value: '4', label: 'הוצא/הוזמן טופס מידע להיתר בלבד (תנאי סף חובה להגשה)' },
];

/** Statutory maturity values that show optional existing building permit upload (file_mm4m76fa). */
export const STATUTORY_MATURITY_BUILDING_PERMIT_FILE_VALUES = ['2', '3', '4'] as const;

export function showExistingBuildingPermitField(statutoryMaturity: string): boolean {
  return (STATUTORY_MATURITY_BUILDING_PERMIT_FILE_VALUES as readonly string[]).includes(
    statutoryMaturity,
  );
}

export const VENTURE_LOCATION_OPTIONS = [
  { value: '1', label: 'מיזם בשטח החקלאי הפתוח' },
  { value: '2', label: 'מיזם הנשען על בינוי קיים של מבנה חקלאי או צמוד אליו' },
  { value: '3', label: 'מיזם בתחום הישוב' },
  { value: '4', label: 'מיזם בשטח החקלאי הפתוח צמוד לפיתוח קיים' },
];

export const ACTIVITY_STATUS_OPTIONS = [
  { value: '1', label: 'מיזם קיים ופעיל המבקש הרחבה, שדרוג או שיפוץ' },
  { value: '2', label: 'מיזם מתוכנן חדש לחלוטין' },
];

export const READINESS_OPTIONS = [
  {
    value: '0',
    label:
      'בתכנון מתקדם: קיימות תוכניות עבודה / סקיצות אדריכליות, לקראת או בעיצומו של הליך רישוי',
  },
  { value: '1', label: 'רעיון ראשוני בלבד: טרם גובשו תוכניות פיזיות או עסקיות מוגדרות' },
  {
    value: '2',
    label:
      'התקיימו כבר פעילויות ניסיון / פיילוט במקום: המודל התיירותי נבחן בפועל באופן חלקי או זמני בשטח ונדרש כעת למסד, לשדרג או להרחיב אותו',
  },
];

export const AGRICULTURAL_INTEGRATION_OPTIONS = [
  {
    value: '0',
    label:
      'כן, שילוב ישיר : המיזם מהווה נדבך נלווה ומשלים ישירות למשק חקלאי פעיל (לדוגמה: מרכז מבקרים בצמוד לבית בד פעיל, סיורים במטעים קיימים, טעימות תוצרת עצמית של המשק)',
  },
  {
    value: '1',
    label:
      'כן, שילוב עקיף - המיזם קשור לתרבות, למורשת ההתיישבותית או לכלכלת המרחב הכפרי, אך אינו נשען על משק חקלאי פעיל ספציפי של היזם',
  },
  { value: '2', label: 'לא: המיזם הינו תיירותי/משלים בלבד ללא זיקה ישירה לחקלאות יצרנית' },
];

export const BUILDING_ELEMENTS_OPTIONS = [
  { value: 1, label: 'בנייה קבועה (מבנה קשיח חדש או שיפוץ מבנה קיים)' },
  {
    value: 2,
    label: 'שימוש במבנים קיימים (סככה חקלאית, מבנה היסטורי, מבנה משק, מבנה לגידול בע"ח).',
  },
  {
    value: 3,
    label: 'פיתוח חצר, תשתיות קלות, פרגולה, סככת צל, שילוט והנגשה בלבד (ללא מבנים)',
  },
  { value: 7, label: 'מתקן נייד (עגלת קפה, פתרונות תצוגה ניידים, דוכני מכירה)' },
  { value: 8, label: 'מבנה יביל / קל / בד (אוהל אירוח וכדומה)' },
];

export const REQUIRED_CONNECTIONS_OPTIONS = [
  { value: 0, label: 'מים' },
  { value: 1, label: 'ביוב' },
  { value: 2, label: 'חשמל' },
];

export const SHADED_GATHERING_OPTIONS = [
  { value: '0', label: 'קיים כבר במקום' },
  { value: '1', label: 'מתוכנן ונדרש להקמה/שדרוג במסגרת הבקשה' },
  { value: '2', label: 'לא קיים ולא מתוכנן' },
];

export const SANITATION_OPTIONS = [
  { value: '0', label: 'אין כרגע פתרון שירותים במתחם המיזם' },
  { value: '3', label: 'מתוכנן פתרון של שירותים כימיים / שירותים ניידים זמניים' },
  { value: '4', label: 'מתוכננת הקמת תאי שירותים חדשים (מבנה קבוע או יביל) במסגרת המענק' },
  { value: '5', label: 'קיימים שירותים קבועים מוסדרים (כולל נגישות נכים)' },
];

export const ACCESSIBILITY_OPTIONS = [
  { value: '0', label: 'המקום נגיש להגעה של רכב פרטי בלבד' },
  { value: '1', label: 'המקום נגיש להגעה של רכב פרטי ואוטובוסים' },
  { value: '2', label: 'המקום לא נגיש להגעה של כלי תחבורה כלל' },
];

export const SIMULTANEOUS_CAPACITY_OPTIONS = [
  { value: '0', label: 'המיזם ערוך לקליטת 2 קבוצות של 25 איש במקביל' },
  { value: '1', label: 'המיזם מיועד למבקרים בודדים / קבוצות קטנות בלבד' },
  { value: '4', label: 'המיזם ערוך לקליטת קבוצות של 50 איש ומעלה בו-זמנית (גודל אוטובוס)' },
];
